export default __webpack_public_path__ + "static/events-dark-4bb9a9651927ceea1706f803bdf9c47d.png";